<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<div class="form">
  <div class="form-container outer">
    <div class="form-form">
      <div class="form-form-wrap">
        <div class="form-container">
          <div [hidden]="loading" class="form-content">
            <h1 translate>Sign In <span *ngIf="isSubAccount" translate>Sub Account</span></h1>
            <p *ngIf="!isSubAccount" translate>Log in to your account to continue.</p>
            <p *ngIf="isSubAccount" translate>Log in to your sub-account to continue.</p>
            <form [formGroup]="loginForm" class="text-left" novalidate>
              <div class="form">
                <div *ngIf="serverMsg" class="d-flex text-danger bg-danger-20 border border-danger rounded p-3 m-1">
                  <div class='mx-auto' translate>{{ serverMsg }}</div>
                </div>
                <!--                <div id="username-field" class="field-wrapper input">-->
                <!--                  <label for="mobile" translate>Username</label>-->
                <!--                  <input [readOnly]="otpPhase? 'readOnly' : ''" [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }" formControlName="mobile" id="mobile" name="mobile" type="tel" class="form-control" [placeholder]="(isSubAccount? 'Enter Gov Id / Mobile' : 'Enter your username') | translate">-->
                <!--                  <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">-->
                <!--                    <div *ngIf="!isSubAccount && f.mobile.errors.required" translate>Please enter a valid username</div>-->
                <!--                    <div *ngIf="isSubAccount && f.mobile.errors.required" translate>Please enter a valid gov id</div>-->
                <!--                  </div>-->
                <!--                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone">-->
                <!--                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>-->
                <!--                  </svg>-->
                <!--                </div>-->

                <div id="username-field" class="field-wrapper input position-relative">
                  <label for="mobile" translate>Username</label>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-phone position-absolute"
                    style="top: 50%; left: 10px; transform: translateY(-50%); z-index: 1;"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                  <input
                    [readOnly]="otpPhase ? 'readOnly' : ''"
                    [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }"
                    formControlName="mobile"
                    id="mobile"
                    name="mobile"
                    type="tel"
                    class="form-control pl-5"
                    [placeholder]="(isSubAccount ? 'Enter Gov Id / Mobile' : 'Enter your username') | translate"
                  />
                  <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                    <div *ngIf="!isSubAccount && f.mobile.errors.required" translate>
                      Please enter a valid username
                    </div>
                    <div *ngIf="isSubAccount && f.mobile.errors.required" translate>
                      Please enter a valid gov id
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="isSubAccount && otpPhase">
                  <label translate>Main Merchant Account</label>
                  <div class="input-group">
                    <select [ngClass]="{'is-invalid': f.mainMerchantId.errors && submitted}" formControlName="mainMerchantId" class="form-control text-left" id="mainMerchantId">
                      <option value=""></option>
                      <option *ngFor="let m of mainMerchantsList" [value]="m.merchantId">{{ m.merchantAccount }} - {{ m.merchantName }}</option>
                    </select>
                  </div>
                  <span class="invalid-feedback" *ngIf="submitted && f.mainMerchantId.errors && f.mainMerchantId.errors.required">This field is required</span>
                  <span class="invalid-feedback" *ngIf="submitted && f.mainMerchantId.errors && f.mainMerchantId.errors.pattern">This field has invalid value</span>
                </div>

                <div id="password-field" *ngIf="otpPhase" class="field-wrapper input mb-2">
                  <div class="d-flex justify-content-between">
                    <label for="password" translate>Password</label>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  <input #password [ngClass]="{'is-invalid' : submitted && f.password.errors}" formControlName="password" id="password" name="password" type="password" class="form-control" [placeholder]="'Password' | translate">
                  <div *ngIf="submitted && f.password.errors" class="invalid-feedback" translate>
                    Please enter a valid password
                  </div>
                  <svg (click)="togglePassword()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="toggle-password" class="feather feather-eye">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
                <div id="otp-field" *ngIf="otpPhase" class="field-wrapper input mb-2">
                  <div class="d-flex justify-content-between">
                    <label for="otp" translate>OTP</label>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  <input #otp [ngClass]="{'is-invalid' : submitted && f.otp.errors}" formControlName="otp" id="otp" name="otp" type="password" class="form-control" [placeholder]="'OTP' | translate">
                  <div *ngIf="submitted && f.otp.errors" class="invalid-feedback" translate>
                    Please enter a valid OTP
                  </div>
                  <svg (click)="toggleOtp()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="toggle-password" class="feather feather-eye">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
                <div class="my-1 mb-3">
                  <a routerLink='/auth/recover-password' translate class="forgot-pass-link">Forgot Password?</a>
                </div>
                <div class="d-sm-flex justify-content-between">
                  <div class="field-wrapper">
                    <button type="submit" *ngIf="!otpPhase" [hidden]="isSubAccount" (click)="next($event)" class="btn btn-primary" translate>Next</button>
                    <button type="submit" *ngIf="!otpPhase" [hidden]="!isSubAccount" (click)="next($event)" class="btn btn-primary" translate>Next with Sub Account</button>
                    <button type="submit" *ngIf="otpPhase" (click)="login($event)" class="btn btn-primary" translate>Log In</button>
                  </div>
                </div>
                <div class="my-1 mb-3">
                  <a *ngIf="!isSubAccount" (click)="toggleSubAccount()" translate class="forgot-pass-link">Sub Account?</a>
                  <a [hidden]="!isSubAccount" (click)="toggleSubAccount()" class="forgot-pass-link">{{ 'Main Account?' | translate }}</a>
                </div>
                <p class="signup-link">{{ 'Not registered?' | translate }}<a href="https://register.paylink.sa" translate>Create an account</a></p>
              </div>
            </form>
          </div>
          <div [hidden]="!loading" class="form-content">
            <div class="d-flex">
              <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
